import i18n from '@/utils/i18n';
import React from 'react';
import { BarGraph } from './bar-graph';
import { GraphItemData } from './types';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { TimeRange } from '@/components/locations/types';
import { TYPOGRAPHY } from '@/styles';

interface TotalSalesGraphProps {
  salesData: GraphItemData[];
  timePeriod: TimeRange;
}

export const TotalSalesGraph: React.FC<TotalSalesGraphProps> = ({
  salesData,
  timePeriod,
}) => {
  const chartPadding = {
    bottom: 32,
    left: 36,
    right: Platform.OS !== 'web' ? 56 : 8,
    top: 8,
  };

  return (
    <>
      {salesData.length > 0 ? (
        <View style={styles.container}>
          <Text style={styles.h3BoldWithFontSize}>
            {i18n.t('dsr_analytics.total_sales', { timePeriod: timePeriod })}
          </Text>
          <BarGraph
            chartPadding={chartPadding}
            currencySymbol="$"
            salesData={salesData}
            showXAxisLabels={false}
            timePeriod={timePeriod}
          />
        </View>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: 24,
  },
  h3BoldWithFontSize: {
    ...TYPOGRAPHY.h3,
    fontSize: 11,
  },
});
